const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addTickets: ({ commit }, ticket) => {
    commit('add', { ...ticket, timer: ticket?.timer || null });
  }
};

const mutations = {
  add: (state, ticket) => {
    state.byId[ticket.id] = ticket;
    if (state.allIds.includes(ticket.id)) return;
    state.allIds.push(ticket.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
